import moize from 'moize';
import moment from 'moment';
import { displayCurrency, displayShortDate } from './Format/Format';

import { trpTickerOverLap } from '../cards/RiskPotential/util';

import { FUND_TYPES, FUND_DOMAIN } from './constants';

export const generalizeFund = (resp) =>
    resp.exchangeTradedFund
        ? { fund: resp.exchangeTradedFund }
        : { fund: resp.mutualFund };

/* story US302833 hiding GIF and GII */
export const fundsToHideTrpCode = [
    'ICM',
    'GIF',
    'GII',
    'SMM',
    'CAM',
    'CMI',
    'NYM',
    'YMI'
];

export const isBuyRestricted = (
    openToNewInvestors,
    openToSubsequentInvestments
) => !(openToNewInvestors || openToSubsequentInvestments);

export const filterFunds = (funds) =>
    funds.filter((fund) => fund && !fundsToHideTrpCode.includes(fund.trpCode));

/* BECASUE THE GRAPHQL FUND PATTERN WAS NOT FOLLOwED FOR THE WATCHLIST */
export const fundsToHidebyTicker = [
    'TRSXX',
    'TGTIX',
    'PRGIX',
    'PCTXX',
    'TCBXX',
    'NYTXX',
    'TRNXX'
];

// empty for the fund event interim state
// can be populated with the tickers once
// we're ready to start redirects to AEM
// pages
export const fundsWithAlternatePages = [];

export const filterFundsByTicker = (funds) =>
    funds.filter(
        (ele) => ele.value && !fundsToHidebyTicker.includes(ele.value)
    );

export const filterFundsByTickerGQL = (funds = []) =>
    funds.filter(
        (ele) => ele.ticker && !fundsToHidebyTicker.includes(ele.ticker)
    );

export const filterFundsByIPOdate = (funds) =>
    funds.filter(
        (ele) => ele.ticker && !fundsToHidebyTicker.includes(ele.ticker)
    );

export const redirectTickerToScreener = (ticker) =>
    fundsToHidebyTicker.includes(ticker) ? '86' : ticker;

export const redirectTickerToAltPage = ({
    ticker,
    openToNewInvestors,
    openToSubsequentInvestments
}) =>
    isBuyRestricted(openToNewInvestors, openToSubsequentInvestments) &&
    fundsWithAlternatePages.includes(ticker);

/**
 * @todo move this to metadata service  GIF
 * @NOTE this file contains all the wonky biz logic
 * that was dictated to us without any explanation
 * or understanding as to why. Likely it should
 * come from an upstream data service and exposed
 * as fund metadata, so that it can be changed/managed
 * appropriately and other clients (e.g. future websites,df
 * mobile apps, reporting)  can have access to this information.
 *
 */

/* @note: per US112759 */
export const getAssetValue = (price, moneyMarket) =>
    displayCurrency(price, moneyMarket && price !== 1.0 ? 4 : 2);

export const getDailyChange = (price, change, moneyMarket) =>
    displayCurrency(change, moneyMarket && price !== 1.0 ? 4 : 2);

// funds not covered by Morningstar - per Brett Tilly
const fundsUnsupportedByMorningstar = ['TRAMX', 'TREMX', 'PRAMX', 'TTEEX'];
// 'special case' funds that shouldn't show any morningstar stars
export const isUnsupportedByMorningstar = (ticker) =>
    fundsUnsupportedByMorningstar.includes(ticker);

const date2018 = 'July 1, 2018';
const date2019 = 'June 1, 2019';
const dec2019 = 'December 1, 2019';

export const showSectorCustomReportingDisclaimer = (ticker) =>
    ['PRMTX', 'TTMIX', 'PRSCX', 'TSNIX', 'PGTIX', 'PRGTX'].includes(ticker);

// @note @rally US112224
// returns the date of the disclaimer to signal the
// shift from gross to net dividend with tax witholdings benchmark
// or undefined if this benchark should not be shown
export const getGrossToNetDate = (ticker) =>
    ({
        // start 2018
        TRAMX: date2018,
        PRAMX: date2018,
        TRAOX: date2018,
        TRASX: date2018,
        TREMX: date2018,
        TTEEX: date2018,
        PRMSX: date2018,
        PRZIX: date2018,
        PRESX: date2018,
        TEUIX: date2018,
        RPGEX: date2018,
        RGGIX: date2018,
        PRGSX: date2018,
        TRGLX: date2018,
        PRGTX: date2018,
        PGTIX: date2018,
        PRCNX: date2018,
        RICIX: date2018,
        PRITX: date2018,
        PRIUX: date2018,
        TRIGX: date2018,
        TRTIX: date2018,
        PRLAX: date2018,
        RLAIX: date2018,
        PRASX: date2018,
        PNSIX: date2018,
        PRNEX: date2018,
        TRNEX: date2018,
        TROSX: date2018,
        TROIX: date2018,
        // start june 2019
        PGLOX: date2019,
        RPGIX: date2019,
        TRGAX: date2019,
        TRGRX: date2019,
        TIRGX: date2019,
        PIEQX: date2019,
        PRIDX: date2019,
        TIDDX: date2019,
        PRJPX: date2019,
        RJAIX: date2019,
        PSILX: date2019,
        // start december 2019
        TPPAX: dec2019,
        TRPBX: dec2019,
        TRSGX: dec2019,
        TGIPX: dec2019,
        PRSIX: dec2019,
        PPIPX: dec2019,
        RPBAX: dec2019,
        RBAIX: dec2019,
        RPGAX: dec2019,
        TGAFX: dec2019,
        PRSGX: dec2019,
        TRRFX: dec2019,
        TRRAX: dec2019,
        TRRGX: dec2019,
        TRRBX: dec2019,
        TRRHX: dec2019,
        TRRCX: dec2019,
        TRRJX: dec2019,
        TRRDX: dec2019,
        TRRKX: dec2019,
        TRRMX: dec2019,
        TRRNX: dec2019,
        TRRLX: dec2019,
        TRRIX: dec2019,
        TRPTX: dec2019,
        TRPFX: dec2019,
        TRPAX: dec2019,
        TRFGX: dec2019,
        TRBRX: dec2019,
        TRPHX: dec2019,
        TRPCX: dec2019,
        TRPJX: dec2019,
        TRPDX: dec2019,
        TRPKX: dec2019,
        TRPMX: dec2019,
        TRPNX: dec2019,
        TRPLX: dec2019,
        TRLAX: dec2019,
        TRARX: dec2019,
        TFRRX: dec2019,
        TRROX: dec2019,
        TORFX: dec2019,
        TRRTX: dec2019,
        TTRTX: dec2019,
        TRRUX: dec2019,
        TTURX: dec2019,
        TRRVX: dec2019,
        TRVVX: dec2019,
        TRRWX: dec2019,
        TWRRX: dec2019,
        RPGRX: dec2019,
        TPGPX: dec2019,
        TRHRX: dec2019,
        TRXRX: dec2019,
        RPTFX: dec2019,
        TRFWX: dec2019,
        TRFOX: dec2019,
        TOORX: dec2019,
        TRFFX: dec2019,
        TRPPX: dec2019,
        TRTFX: dec2019,
        TTOIX: dec2019
    }[ticker]);

/**
 * returns false if the fund is ready to show because the most recent quarter end
 * was NOT before the inception date THEREFORE at least one quarter end has passed
 * since the fund was incepted.
 * @param {string} inceptionDate the date the was incepted as a string
 * @returns {boolean} true if the fund's inception occured after the most recent quarter end
 */
export const quarterEndBeforeInception = (inceptionDate) => {
    const previousQuarter =
        moment().quarter() - 1; /* get previous quarter (1, 2, 3, 4) */
    const previousQuarterEnd = moment()
        .quarter(previousQuarter)
        .endOf('quarter')
        .format();
    return (
        inceptionDate &&
        moment(previousQuarterEnd).isBefore(moment(inceptionDate))
    );
};

export const isTaxEfficient = (name) => /Tax-Efficient/i.test(name);

// I Class funds should display hollow stars if less than targeted years
// Targeted year should coincide with 3, 5, or 10 yr marks
const tackedByDate = (inception, year) =>
    inception && new Date().getFullYear() - inception.split('-')[0] < year;
// combine buisness logic to determine if morningstar stars should be hollow
export const isTacked = (iClass, inception, year) =>
    iClass && tackedByDate(inception, year);

export const getFundDomain = ({ assetClassName }) => {
    if (/international/i.test(assetClassName)) return FUND_DOMAIN.INTERNATIONAL;

    if (/domestic/i.test(assetClassName)) return FUND_DOMAIN.DOMESTIC;

    return false;
};

export const showExpenseWaiverDisclaimer = (ticker) =>
    ['PRIMX', 'PRTMX', 'PRINX', 'PRSMX'].includes(ticker);

export const showTackedFootnotes = (iClass) => iClass;

export const getFundCategory = ({ bond, moneyMarket, assetClassName }) => {
    if (/blended/i.test(assetClassName)) {
        return FUND_TYPES.BLENDED_ASSET;
    }

    if (bond) return FUND_TYPES.BOND;

    if (moneyMarket) return FUND_TYPES.MONEY_MARKET;

    if (/stock/i.test(assetClassName)) {
        return FUND_TYPES.STOCK;
    }

    return false;
};

export const getBoradAssetCategory = (broadAssetClass) =>
    /allocation/i.test(broadAssetClass) || /alternative/i.test(broadAssetClass);

export const getFundType = moize.deep((mutualFund) => {
    const res = {
        geographicDomain: getFundDomain(mutualFund),
        stockDomain: getFundCategory(mutualFund),
        iClass: mutualFund.iClass,
        taxEfficient: isTaxEfficient(mutualFund.name)
    };
    return res;
});

const riskLevels = [200, 210, 220, 230, 240, 250, 260, 270, 280, 290];
const riskLevelMapping = (lvl) => riskLevels.indexOf(lvl);

export const riskLevelCategory = (lvl, ticker) => {
    const level = riskLevelMapping(lvl);
    const plusRisk = trpTickerOverLap;
    const plusPlusRisk = ['RPIEX', 'RPEIX', 'TMSRX', 'TMSSX', 'RPIDX', 'RPELX'];
    let riskDeviation = '';

    if (plusRisk.includes(ticker)) riskDeviation = '3';
    if (plusPlusRisk.includes(ticker)) riskDeviation = '4';
    if (plusRisk.includes(ticker) && plusPlusRisk.includes(ticker))
        riskDeviation = '3, 4';
    if (level < 3) return [`Lower`, riskDeviation];
    if (level < 7) return [`Moderate`, riskDeviation];
    return [`Higher`, riskDeviation];
};

/**
 * @TODO get off of using this and check the fund's assetClassName instead.
 * **ESSENTIALLY THIS IS DEPRECATED**
 *
 * Checks whether the fund is on a hardcoded list of Fixed Income ETF tickers
 * @param {string} fund
 * @returns {boolean} True if the fund is Fixed Income
 */
export const isFixedIncomeETF = (ticker) =>
    ['FIETF1', 'TAGG', 'TOTR', 'TBUX', 'THYF', 'TFLR'].includes(ticker);

export const isContractualETF = (ticker) => ['THEQ'].includes(ticker);

export const isOlderThanLipper = (ticker) =>
    ['PRRXX', 'TTGXX', 'PTEXX', 'TERXX', 'PRTXX', 'TRGXX'].includes(ticker);

export const isAllocationFund = (broadAssetClass, investmentStyleName) =>
    ['Multi-Asset', 'Alternative'].includes(broadAssetClass) &&
    investmentStyleName !== 'Target Date';

/**
 * Checks whether current date is less than next month to inception date
 * plus specified business days
 * @param {string} fund
 * @param {string} inceptionDate
 * @param {number} numberOfBusinessDays
 *
 * @returns {boolean} Is current date is less than next month to inception date
 * plus specified business days
 */
export const shouldDisplayNewFundMessage = (
    fund,
    inceptionDate,
    numberOfBusinessDays = 6
) => {
    if (!isFixedIncomeETF(fund)) {
        return false;
    }

    const inceptionDateObj = new Date(inceptionDate);

    let year = inceptionDateObj.getFullYear();
    let month = inceptionDateObj.getMonth() + 1;
    let days = 0;

    if (month === 12) {
        month = 0;
        year += 1;
    }

    let date = 1;
    let dateUntilFundIsNew = new Date(year, month);

    while (days < numberOfBusinessDays) {
        const day = dateUntilFundIsNew.getDay();
        let increment = 0;

        if (day !== 0 && day !== 6) {
            days += 1;
            increment = 1;
        } else if (day === 0) {
            increment = 1;
        } else if (day === 6) {
            increment = 2;
        }

        if (days !== numberOfBusinessDays) {
            date += increment;

            dateUntilFundIsNew = new Date(dateUntilFundIsNew.setDate(date));
        }
    }

    return Date.now() < dateUntilFundIsNew.getTime();
};

export const newFundUtil = (incDate, timeToCompare) => {
    const timeFrame = timeToCompare || 'years';
    const fundAge = moment().diff(incDate, timeFrame);
    return fundAge < 1;
};

export const displayWeightedTitle = (trpCode, dspWorstLabel = '') =>
    dspWorstLabel.includes(trpCode)
        ? 'Modified Duration to Worst'
        : 'Weighted Average Duration';

export const getMonthFromDate = (date, ticker) => {
    if (['TCRRX', 'PGMSX'].includes(ticker)) return 'May';
    if (['RPGAX', 'TGAFX'].includes(ticker)) return 'October';
    const d = moment.utc(date);
    return d.isValid()
        ? moment.utc(date, moment.ISO_8601).format('MMMM')
        : date;
};

export const inceptionDateHardCodedToBeRemoved = (
    iClass,
    tackedReturnFundInceptionDate,
    inceptionDate
) =>
    iClass && tackedReturnFundInceptionDate
        ? displayShortDate(tackedReturnFundInceptionDate)
        : displayShortDate(inceptionDate);

export const displayETFDisclaimer = (ticker) =>
    ![
        'RPBAX',
        'RBAIX',
        'TGAFX',
        'RPGAX',
        'PRSIX',
        'TRSGX',
        'TRPBX',
        'PPIPX',
        'TGIPX',
        'TPPAX',
        'PRIKX',
        'PRAFX'
    ].includes(ticker);

// this array is list of funds that qualify for TIPS Funds disclosure
export const tipsFunds = ['PRIPX', 'TIIPX', 'TRBFX', 'TRLDX', 'TLDTX', 'TLDUX'];
